<template>
  <label class="form-checkbox__wrap">
    <input
      :name="name"
      :class="{error: showError}"
      value="value"
      v-model="model"
      @change="handleChange"
      type="checkbox">
    <span class="form-checkbox"></span>
    <slot />
  </label>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    showError: {
      type: Boolean | undefined,
      required: true
    }
  },
  data () {
    return {
      model: false
    }
  },
  mounted () {
    this.model = this.value
  },
  watch: {
    value: function (val, oldVal) {
      this.model = val
    }
  },
  methods: {
    handleChange (event) {
      const isChecked = event.target.checked
      this.$emit('input', isChecked)
      this.$emit('change', isChecked)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assetComponents/Checkbox.vue